export const MESSAGE_CODE_SYSTEM_BUSY = 10000
export const MESSAGE_CODE_CODE_ALREADY_EXIST = 10007

export const MESSAGE_CODE_DUPLICATE_CODE = 60004
export const MESSAGE_CODE_SPECIFIC_PART_IS_EMPTY = 60005
export const MESSAGE_CODE_DUPLICATE_PREFIX = 60007
export const MESSAGE_CODE_INVALID_GIFT_QTY = 60008

export const salesDashboardMessageCodeMap = new Map([
  [MESSAGE_CODE_SYSTEM_BUSY, "system_is_busy"],
  [MESSAGE_CODE_CODE_ALREADY_EXIST, "code_already_exist"],
  [MESSAGE_CODE_DUPLICATE_CODE, "duplicate_code"],
  [MESSAGE_CODE_SPECIFIC_PART_IS_EMPTY, "specific_part_is_empty"],
  [MESSAGE_CODE_DUPLICATE_PREFIX, "duplicate_prefix"],
  [MESSAGE_CODE_INVALID_GIFT_QTY, "invalid_gift_qty"],
])
